/* eslint-disable */
import { useEffect, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import api from "../lib/api";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || "";

  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState(null);
  const [done, setDone] = useState(false);

  useEffect(() => {
    if (!token) {
      setMsg({ ok: false, text: "This reset link is missing its token. Request a new email." });
    }
  }, [token]);

  async function onSubmit(e) {
    e.preventDefault();
    if (!token) return;
    if (password.length < 6) {
      setMsg({ ok: false, text: "Password must be at least 6 characters." });
      return;
    }
    if (password !== confirm) {
      setMsg({ ok: false, text: "Passwords don't match." });
      return;
    }
    setBusy(true); setMsg(null);
    try {
      const r = await api.post("/auth/reset-password", { token, new_password: password });
      setDone(true);
      setMsg({ ok: true, text: r.data?.message || "Password updated. You can now log in." });
      setTimeout(() => navigate("/login", { replace: true }), 2500);
    } catch (err) {
      const detail = err?.response?.data?.detail || "Reset failed. The link may have expired.";
      setMsg({ ok: false, text: detail });
    } finally { setBusy(false); }
  }

  return (
    <div className="m-auth-page">
      <div className="m-auth-aside">
        <div className="m-auth-logo-wrap">
          <img src="/brand/metier-logo-gold.png" alt="Métier" />
        </div>
        <div>
          <span className="m-eyebrow">Métier · Membership</span>
          <h1 className="m-auth-heading">New <em>password</em>.</h1>
          <p className="m-auth-lede">Choose something you&apos;ll remember but hard to guess.</p>
        </div>
        <div className="m-auth-foot-aside"><span>workmetier.com</span></div>
      </div>
      <div className="m-auth-main">
        <div className="m-auth-card">
          <span className="m-eyebrow">Reset password</span>
          <h2 className="m-auth-h2">Set a <em>new one</em>.</h2>
          <p className="m-auth-lede">
            This link is one-time and expires 30 minutes after we sent it.
          </p>

          {done ? (
            <div className="m-form-msg ok" data-testid="reset-done">
              {msg?.text} Redirecting to sign in…
            </div>
          ) : (
            <form onSubmit={onSubmit} className="m-form">
              <label className="m-field">
                <span>New password</span>
                <input
                  type="password"
                  value={password}
                  onChange={e => setPassword(e.target.value)}
                  required
                  minLength={6}
                  autoComplete="new-password"
                  data-testid="reset-password"
                />
              </label>
              <label className="m-field">
                <span>Confirm password</span>
                <input
                  type="password"
                  value={confirm}
                  onChange={e => setConfirm(e.target.value)}
                  required
                  minLength={6}
                  autoComplete="new-password"
                  data-testid="reset-confirm"
                />
              </label>
              {msg && (
                <div className={"m-form-msg " + (msg.ok ? "ok" : "err")} data-testid="reset-msg">
                  {msg.text}
                </div>
              )}
              <button
                type="submit"
                className="m-btn-gold"
                disabled={busy || !token}
                data-testid="reset-submit"
              >
                {busy ? "Updating…" : "Update password"}
              </button>
            </form>
          )}

          <p className="m-auth-foot">
            <Link to="/login" data-testid="link-back-login">Back to sign in →</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
